//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import NoticeList from "./components/noticeList";

export default {
    name: "my-notice",
    components: {NoticeList},
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            member: {},
            unreadCount: 0,
            readCount: 0,
            systemMessageCount: {
                readCount: 0,
                unReadCount: 0,
            }
        }
    },
    methods: {
        getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.member = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.member.id);
                this.getCount()

            }).finally(() => {
                this.$toast.clear();
            });
        },
        message(d) {
            this.unreadCount = d;
        },
        read(val) {
            this.readCount = val;
        },
        getCount() {
            abp.ajax.get('/api/services/app/SystemMessage/GetReadCount?memberId=' + this.member.id).then((res) => {
                this.systemMessageCount = res.data.result
            })
        }
    },
    created() {
        this.getMyMember();
    }
};
